module.exports = __webpack_public_path__ + "img/livemap_all.491608a2.png";